import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper'

Swiper.use([Navigation, Pagination, Scrollbar])

$('.js-cardSlider').each((index, el) => {
  new Swiper($('.swiper-container', el)[0], {
    navigation: {
      nextEl: $('.js-cardSliderNext', el)[0],
      prevEl: $('.js-cardSliderPrev', el)[0],
    },
    pagination: {
      el: $('.swiper-pagination', el)[0],
      type: 'bullets',
      clickable: true,
    },
    scrollbar: {
      el: $('.swiper-scrollbar', el)[0],
      draggable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
      1150: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  })
})
